import {isEmpty, cloneDeep, find} from 'lodash'
import {loader, message, logout, errorHandler, routeErrorHandler} from '@/libs/helper'
import constants from '@/libs/constant/constants'
import {removeOrganisation, getOrganisation, getMetaCollectionList, getMetaDossierList} from '@/libs/api/api'
import pageRoute from '@/libs/constant/pageRoutes'
import {mapGetters} from 'vuex'
import OrganisationRolesErrorHandlerMixin from '@/mixins/OrganisationRolesErrorHandlerMixin'
export default {
    name: 'orgSettings',
    mixins: [OrganisationRolesErrorHandlerMixin],
    props: {
        details: {
            type: Object,
            default: () => {}
        },
        organisationDetails: {
            type: Object,
            default: () => {}
        },
        updateFormDataValues: {
            type: Function,
            default: () => {}
        }
    },
    // async beforeRouteEnter (to, from, next) {
    //     try {
    //         let organisation = await getOganisationById(to.params.id)
    //         if (organisation.role === constants.ORGANISATION_RIGHTS.OWNER) next(vm => vm.setOrganisations(organisation))
    //     } catch (error) {
    //         console.error(error)
    //     }
        
    // },
    computed: {
        ...mapGetters({
            storeOrganisationList: 'getOrganisations',
            organisationRoles: 'getOrganisationRoles'
        }),
        isDisabledCollections () {
            return this.isFetchingCollections || !this.isLoadMoreCollections
        },
        isDisabledDossiers () {
            return this.isFetchingDossiers || !this.isLoadMoreDossiers
        },
        hideLeftSideMenu () {
            if (this.$route.name === pageRoute.organisationActiveURLS || this.$route.name==pageRoute.organisationArchiveURLS || this.$route.name === pageRoute.organisationURLDashboard) return true
            return false
        }
    },
    watch: {
        storeOrganisationList (newValue) {
            this.organisationList = cloneDeep(newValue)
            // set organisations
            this.setOrganisations({})
        }
    },
    mounted() {
        // fetch organsiations
        this.fetchOrganisations()
        // fetch collection
        this.fetchCollections()
        // fetch dossier
        this.fetchDossiers()
    },
    data() {
        return {
            isEmpty,
            manageList: [],
            activeMenu: 'profile',
            showDropdown: false,
            organisationList: [],
            collectionList: [],
            dossierList: [],
            selectedCollection: {},
            selectedOrganisation: {},
            dossierSkip: 0,
            collectionSkip: 0,
            limit: 30,
            isLoadMoreCollections: true,
            isFetchingCollections: false,
            isLoadMoreDossiers: true,
            isFetchingDossiers: false
        }
    },
    methods: {

        /**
         * set the left side menu
         */
        setOrganisations (organisation) {
            if (isEmpty(organisation)) {
                organisation = find(this.organisationList, {_id: this.$route.params.id})
            }
            this.selectedOrganisation = !isEmpty(organisation) ? organisation : {}
        },

        /**
         * change menu
         * @param {*} menu 
         */
        changeMenu (menu) {
            this.activeMenu = menu
            this.$router.push(menu)
        },

        /**
         * remove organisation
         * @param {*} listId list-id to be removed
         */
        async leaveOrganisation () {
            this.$confirm('This will permanently remove the Organisation. Continue?', 'Warning', {
                confirmButtonText: 'Remove',
                cancelButtonText: 'Cancel',
                type: 'warning',
                title: 'Remove Organisation'
                }).then(() => {
                    loader(this, true)
                    removeOrganisation(this.$route.params.id).then(() => {
                        this.$store.dispatch('setRefreshOrganisationList', true)
                        loader(this, false)
                        this.$router.push({name: pageRoute.organisationCard})
                    }).catch(error => {
                        message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
                        loader(this, false)  
                    })                    
                }).catch(error => {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
                });
        },

        /**
         * fetch the list of organisations
         */
        async fetchOrganisations () {
            try {
                this.organisationList = cloneDeep(this.$store.getters.getOrganisations || {})
                if (isEmpty(this.organisationList)) {
                    let response = await getOrganisation()
                    // filter owners
                    let owners = response.filter(org => org.role === constants.ORGANISATION_RIGHTS.OWNER)
                    this.organisationList = owners
                    // set list in store
                    this.$store.dispatch('setOrganisations', cloneDeep(owners))
                }
                // set organisation
                this.setOrganisations({})
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
            }
        },

        /**
         * route to settings page
         * @param {*} organisation 
         */
        routeToSettingsPage (organisation) {
            // set org in left side dropdown
            this.setOrganisations(organisation)
            // route to new ORG
            this.$router.push({name: pageRoute.organisationSettings, params: {id: organisation._id}})
            // clear collection fields
            this.clearCollectionFields()
            // clear dossier fields
            this.clearDossierFields()
            // fetch collections
            this.fetchCollections()
            // fetch dossiers
            this.fetchDossiers()
            // update roles permissions
            this.$store.dispatch('setUpdateOrganisationRoles', true)
        },
        /**
         * to fetch collections 
         */
        async fetchCollections (isLoadMore) {
            try {
                this.isFetchingCollections = true
                // params for api
                let params = {
                    skip: this.collectionSkip,
                    limit: this.limit
                }
                // body for api
                let body = {
                    entity_type: constants.ORGANISATIONS.ORGANISATION,
                    entity_id: this.$route.params.id
                }
                // api call
                let response = await getMetaCollectionList(body, params)
                // if loading more than concat the list
                if (isLoadMore) this.collectionList = this.collectionList.concat(response.items || [])
                // initialise the list
                else {
                    this.collectionList = response.items || []
                    // this.selectedCollection = (response.items && response.items[0]) || {}
                }
                // increase the skip
                this.collectionSkip += this.limit
                if (response.item_count < this.limit) {
                    this.isLoadMoreCollections = false
                }
            } catch (error) {
                this.isLoadMoreCollections = false
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
            }
            // to make fetching false
            this.isFetchingCollections = false
        },

        /**
         * to fetch collections 
         */
        async fetchDossiers (isLoadMore) {
            try {
                this.isFetchingDossiers = true
                // params for api
                let params = {
                    skip: this.dossierSkip,
                    limit: this.limit
                }
                // body for api
                let body = {
                    entity_type: constants.ORGANISATIONS.ORGANISATION,
                    entity_id: this.$route.params.id
                }
                // api call
                let response = await getMetaDossierList(body, params)
                // if loading more than concat the list
                if (isLoadMore) this.dossierList = this.dossierList.concat(response.items || [])
                // initialise the list
                else {
                    this.dossierList = response.items || []
                    // this.selectedCollection = (response.items && response.items[0]) || {}
                }
                // increase the skip
                this.dossierSkip += this.limit
                if (response.item_count < this.limit) {
                    this.isLoadMoreDossiers = false
                }
            } catch (error) {
                this.isLoadMoreDossiers = false
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
            }
            // to make fetching false
            this.isFetchingDossiers = false
        },

        /**
         * infinite loading handler collection
         */
        handleCollectionInfiniteLoading () {
            if (!this.isFetchingCollections && this.isLoadMoreCollections) this.fetchCollections(true)
        },

        /**
         * infinite loading handler dossier
         */
        handleDossierInfiniteLoading () {
            if (!this.isFetchingDossiers && this.isLoadMoreDossiers) this.fetchDossiers(true)
        },

        /**
         * clear collection fields
         */
        clearCollectionFields() {
            this.collectionSkip = 0
            this.isLoadMoreCollections = true
        },

        /**
         * clear dossier fields
         */
        clearDossierFields () {
            this.dossierSkip = 0
            this.isLoadMoreDossiers = true
        }
    }
}